// <s-product-link-previews>: places the server-rendered product chips (one <template> per product) right after the first text link to that product in the article body.
class ProductLinkPreviews extends HTMLElement {
  connectedCallback() {
    const body = document.querySelector(this.dataset.target || '[data-article-body]');
    if (!body) return;

    const chips = new Map();
    this.querySelectorAll('template[data-handle]').forEach((template) => chips.set(template.dataset.handle, template));
    if (!chips.size) return;

    body.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      if (link.hasAttribute('data-product-chip') || link.querySelector('img, picture, video')) return;
      const handle = this.handleFrom(link.getAttribute('href'));
      const template = handle && chips.get(handle);
      if (!template) return;
      chips.delete(handle);
      link.after(template.content.cloneNode(true));
    });
  }

  handleFrom(href) {
    try {
      const url = new URL(href, window.location.href);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch {
      return null;
    }
  }
}

if (!customElements.get('s-product-link-previews')) customElements.define('s-product-link-previews', ProductLinkPreviews);
